import { ActionTree } from 'vuex';
import { RootState } from '../store';
import {
  ModalState,
  ContactEditSettings,
  TemplateRoleSettings,
  RecipientEditSettings,
  SettingsIntegrationEnum,
  SettingsEnum,
  SettingsData,
  DocumentEnum,
  DocumentData,
  FieldActionData,
  DealActionData,
  DocumentOwnerData,
} from '../stores/modal.store';
import { EnumPlans } from '@/enums/Plans';

export const actions: ActionTree<ModalState, RootState> = {
  async setModalIsLoading({ commit }, payload: boolean) {
    commit('setModalIsLoading', payload);
  },
  async toggleArchiveUpload({ commit }, payload: boolean) {
    commit('setToggleArchiveUpload', payload);
  },
  async setArchiveUploadData({ commit }, payload: boolean) {
    commit('setArchiveUploadData', payload);
  },
  async toggleContactEdit({ commit }, payload: boolean) {
    commit('setToggleContactEdit', payload);
  },
  async setContactEditSettings({ commit }, payload: ContactEditSettings) {
    commit('setContactEditSettings', payload);
  },
  async toggleTemplateRole({ commit }, payload: boolean) {
    commit('setToggleTemplateRole', payload);
  },
  async setTemplateRoleSettings({ commit }, payload: TemplateRoleSettings) {
    commit('setTemplateRoleSettings', payload);
  },
  async toggleRecipientEdit({ commit }, payload: boolean) {
    commit('setToggleRecipientEdit', payload);
  },
  async setRecipientEditSettings({ commit }, payload: RecipientEditSettings) {
    commit('setRecipientEditSettings', payload);
  },
  async toggleSettings({ commit }, payload: SettingsEnum) {
    commit('setToggleSettings', payload);
  },
  async setSettingsData({ commit }, payload: SettingsData) {
    commit('setSettingsData', payload);
  },
  async toggleSettingsIntegration({ commit }, payload: SettingsIntegrationEnum) {
    commit('setToggleSettingsIntegration', payload);
  },
  async toggleDocument({ commit }, payload: DocumentEnum) {
    commit('setToggleDocument', payload);
  },
  async setDocumentData({ commit }, payload: DocumentData) {
    commit('setDocumentData', payload);
  },
  async toggleFieldAction({ commit }, payload: boolean) {
    commit('setToggleFieldAction', payload);
  },
  async setFieldActionData({ commit }, payload: FieldActionData) {
    commit('setFieldActionData', payload);
  },
  async toggleDealAction({ commit }, payload: boolean) {
    commit('setToggleDealAction', payload);
  },
  async setDealActionData({ commit }, payload: DealActionData) {
    commit('setDealActionData', payload);
  },
  async setAttachmentActionData({ commit }, payload: DealActionData) {
    commit('setAttachmentActionData', payload);
  },
  async toggleDocumentNotification({ commit }, payload: boolean) {
    commit('setToggleDocumentNotification', payload);
  },
  async setDocumentNotificationData({ commit }, payload) {
    commit('setDocumentNotificationData', payload);
  },
  async toggleLoginForm({ commit }, payload: boolean) {
    commit('setToggleLoginForm', payload);
  },
  async toggleDocumentOwner({ commit }, payload: boolean) {
    commit('setToggleDocumentOwner', payload);
  },
  async setDocumentOwnerData({ commit }, data: DocumentOwnerData) {
    commit('setDocumentOwnerData', data);
  },
  async toggleUpgradeModal({ commit }, payload: EnumPlans) {
    commit('setToggleUpgradeModal', payload);
  },
  async toggleShowAccessDeniedModal({ commit }, payload: boolean) {
    commit('setToggleAccessDeniedModal', payload);
  },
};
